<template>
  <div
    class="field-wrapper field-wrapper--text"
    :class="[field.cssClass, {'visually-hidden': field.visibility === 'hidden'}, 'field-wrapper--' + field.size]"
  >
    <div
      class="field-group field-group--block field-group--block-gray"
      :class="[{'field-group--is-error': isError}]"
    >
      <label
        class="label"
        :for="'input_' + formId + '_' + field.id"
        :class="[{'visually-hidden': field.labelPlacement === 'hidden_label'}]"
      >
        {{ field.label }}<sup v-if="field.isRequired">*</sup>
      </label>

      <input
        :id="'input_' + formId + '_' + field.id"
        :name="'input_' + field.id"
        v-model="text"
        @focus="inputFocus"
        @blur="inputBlur"
        :required="field.isRequired"
        :placeholder="field.labelPlacement === 'hidden_label' ? field.placeholder : null"
        type="number"
      >
    </div>

    <slot name="description"></slot>
    <slot name="error"></slot>
  </div>
</template>

<script>
import store from '../store';

import VFieldMixins from './VFieldMixins.vue';
export default {
  store,
  name: "VFieldNumber",
  mixins: [VFieldMixins],
  data () {
    return {
      text: '',
    }
  },


  mounted() {
    if (this.field.label === 'Boot') {
      this.text = this.boatName
    }
  },

  props: {
    formId: Number,
    field: Object,
    fieldKey: Number,
    isError: String,
    boatName: String
  },
  watch: {
    text: {
      immediate: true,
      deep: false,
      handler (newValue) {
        store.commit(
            'UPDATE_USER_FORM_DATA' ,
            {'key': this.field.id, 'value': newValue})

        if (this.field.cssClass.indexOf('firstAndLastName') > -1) {
          const firstAndLastName = newValue.split(' ')

          const firstName = document.querySelector('.field-wrapper.firstName')
          if (firstName) {
            store.commit(
                'UPDATE_USER_FORM_DATA' ,
                {'key': firstName.querySelector('input').getAttribute('id').split('_')[1], 'value': firstAndLastName[0]})
          }

          const lastName = document.querySelector('.field-wrapper.lastName')
          if (lastName) {
            firstAndLastName.shift()
            store.commit(
                'UPDATE_USER_FORM_DATA' ,
                {'key': lastName.querySelector('input').getAttribute('id').split('_')[1], 'value': firstAndLastName.join(' ')})
          }
        }
      }
    }
  }

}
</script>
